// extracted by mini-css-extract-plugin
module.exports = {"root":"FooterBannerSection-module--root--9b848f","img":"FooterBannerSection-module--img--278648"};